export default "__VITE_ASSET__BRMNLMJd__"